import { render, staticRenderFns } from "./input-search.vue?vue&type=template&id=131b209c&scoped=true&"
import script from "./input-search.vue?vue&type=script&lang=ts&"
export * from "./input-search.vue?vue&type=script&lang=ts&"
import style0 from "./input-search.vue?vue&type=style&index=0&id=131b209c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131b209c",
  null
  
)

export default component.exports